import { render, staticRenderFns } from "./NewUsersChart.vue?vue&type=template&id=47ce8298&scoped=true&"
import script from "./NewUsersChart.vue?vue&type=script&lang=js&"
export * from "./NewUsersChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce8298",
  null
  
)

export default component.exports